import { render, staticRenderFns } from "./AccountSave.vue?vue&type=template&id=4aa3d571&"
import script from "./AccountSave.vue?vue&type=script&lang=js&"
export * from "./AccountSave.vue?vue&type=script&lang=js&"
import style0 from "./AccountSave.vue?vue&type=style&index=0&id=4aa3d571&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports